'use client';

import { c as _c } from "react/compiler-runtime";
import { Input } from '@common/components';
import SvgChevrondown from '@common/icon/SvgChevrondown';
import { useState } from 'react';
import type { SelectedRegion } from '@/components/client/RegionSelect/RegionPickerDialog';
import { RegionPickerDialog } from '@/components/client/RegionSelect/RegionPickerDialog';
import { useRegionMetaData } from '@/components/client/RegionSelect/useRegionMetaData';
interface RegionFilterFieldProps {
  regionCode: string | null;
  subRegionCode: string | null;
  onRegionChange: (code: string | null) => void;
  onSubRegionChange: (code: string | null) => void;
  title?: string;
  wholeCountryHint?: string;
  dialogOpened?: boolean;
  onDialogOpenChange?: (opened: boolean) => void;
  renderDialog?: boolean;
}
interface RegionFilterDialogProps {
  opened: boolean;
  onClose: () => void;
  regionCode: string | null;
  subRegionCode: string | null;
  onRegionChange: (code: string | null) => void;
  onSubRegionChange: (code: string | null) => void;
  title?: string;
  wholeCountryHint?: string;
}
export function RegionFilterDialog(t0) {
  const $ = _c(13);
  const {
    opened,
    onClose,
    regionCode,
    subRegionCode,
    onRegionChange,
    onSubRegionChange,
    title: t1,
    wholeCountryHint
  } = t0;
  const title = t1 === undefined ? "\uC9C0\uC5ED\uC744 \uC120\uD0DD\uD574 \uC8FC\uC138\uC694" : t1;
  let t2;
  if ($[0] !== onRegionChange || $[1] !== onSubRegionChange) {
    t2 = t3 => {
      const {
        mainRegion,
        subRegion
      } = t3;
      onRegionChange(mainRegion?.code ?? null);
      onSubRegionChange(subRegion?.code ?? null);
    };
    $[0] = onRegionChange;
    $[1] = onSubRegionChange;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleConfirm = t2;
  const t3 = regionCode ?? undefined;
  const t4 = subRegionCode ?? undefined;
  let t5;
  if ($[3] !== t3 || $[4] !== t4) {
    t5 = {
      mainRegionCode: t3,
      subRegionCode: t4
    };
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== handleConfirm || $[7] !== onClose || $[8] !== opened || $[9] !== t5 || $[10] !== title || $[11] !== wholeCountryHint) {
    t6 = <RegionPickerDialog opened={opened} onClose={onClose} onConfirm={handleConfirm} value={t5} title={title} enableWholeRegion={true} enableWholeCountry={true} wholeCountryHint={wholeCountryHint} />;
    $[6] = handleConfirm;
    $[7] = onClose;
    $[8] = opened;
    $[9] = t5;
    $[10] = title;
    $[11] = wholeCountryHint;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}
export function RegionFilterField(t0) {
  const $ = _c(25);
  const {
    regionCode,
    subRegionCode,
    onRegionChange,
    onSubRegionChange,
    title: t1,
    wholeCountryHint,
    dialogOpened,
    onDialogOpenChange,
    renderDialog: t2
  } = t0;
  const title = t1 === undefined ? "\uC9C0\uC5ED\uC744 \uC120\uD0DD\uD574 \uC8FC\uC138\uC694" : t1;
  const renderDialog = t2 === undefined ? true : t2;
  const [internalDialogOpened, setInternalDialogOpened] = useState(false);
  const regionMetaData = useRegionMetaData().data;
  const isDialogOpened = dialogOpened ?? internalDialogOpened;
  const setDialogOpened = onDialogOpenChange ?? setInternalDialogOpened;
  let t3;
  if ($[0] !== regionCode || $[1] !== regionMetaData?.mainRegionByCode) {
    t3 = regionCode ? regionMetaData?.mainRegionByCode.get(regionCode) : undefined;
    $[0] = regionCode;
    $[1] = regionMetaData?.mainRegionByCode;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const mainRegion = t3;
  let t4;
  if ($[3] !== regionMetaData?.subRegionByCode || $[4] !== subRegionCode) {
    t4 = subRegionCode ? regionMetaData?.subRegionByCode.get(subRegionCode) : undefined;
    $[3] = regionMetaData?.subRegionByCode;
    $[4] = subRegionCode;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const subRegion = t4;
  const selectedRegionText = subRegion ? subRegion.value ?? "" : mainRegion ? `${mainRegion.value} 전체` : regionCode || subRegionCode ? "" : "\uC804\uAD6D";
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <SvgChevrondown className="size-16 text-Gray-700" name={"\uC9C0\uC5ED \uC120\uD0DD \uC5F4\uAE30"} />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== setDialogOpened) {
    t6 = () => setDialogOpened(true);
    $[7] = setDialogOpened;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== selectedRegionText || $[10] !== t6) {
    t7 = <Input readOnly={true} aria-haspopup="dialog" className="w-full" placeholder={"\uC9C0\uC5ED \uC120\uD0DD"} rightContent={t5} type="button" value={selectedRegionText} onClick={t6} />;
    $[9] = selectedRegionText;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== isDialogOpened || $[13] !== onRegionChange || $[14] !== onSubRegionChange || $[15] !== regionCode || $[16] !== renderDialog || $[17] !== setDialogOpened || $[18] !== subRegionCode || $[19] !== title || $[20] !== wholeCountryHint) {
    t8 = renderDialog ? <RegionFilterDialog opened={isDialogOpened} onClose={() => setDialogOpened(false)} regionCode={regionCode} subRegionCode={subRegionCode} onRegionChange={onRegionChange} onSubRegionChange={onSubRegionChange} title={title} wholeCountryHint={wholeCountryHint} /> : null;
    $[12] = isDialogOpened;
    $[13] = onRegionChange;
    $[14] = onSubRegionChange;
    $[15] = regionCode;
    $[16] = renderDialog;
    $[17] = setDialogOpened;
    $[18] = subRegionCode;
    $[19] = title;
    $[20] = wholeCountryHint;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== t7 || $[23] !== t8) {
    t9 = <>{t7}{t8}</>;
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  return t9;
}